import { createContext, useContext } from 'react';
import type { ProjectType } from '@atlassian/jira-common-constants';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import {
	CREATE_PROJECT,
	SITE_ADMIN,
	type ImportType,
	type UserAccess,
} from '../../constants/import-type';
import type { ProjectStyle } from '../../constants/project';
import type { Source } from '../../constants/source';
import { INITIAL_STATE } from '../../constants/state';

export const useUserAccess = (): UserAccess => {
	const { isSiteAdmin } = useTenantContext();
	if (isSiteAdmin) return SITE_ADMIN;
	return CREATE_PROJECT;
};

export type AnalyticsAttributes = {
	projectType: ProjectType | null;
	projectStyle: ProjectStyle | null;
	importType: ImportType;
	userAccess: UserAccess;
	source: Source;
};

export const AnalyticsAttributesContext = createContext<AnalyticsAttributes>({
	projectType: INITIAL_STATE.projectData.type,
	projectStyle: INITIAL_STATE.projectData.style,
	importType: INITIAL_STATE.importType,
	userAccess: CREATE_PROJECT,
	source: INITIAL_STATE.source,
});

export const useAnalyticsAttributesContext = () => useContext(AnalyticsAttributesContext);
